import React from 'react';

import { TOOL_PERMISSION, VIEWS } from 'pages/ToolManagement/toolManagementConfig';

const ToolManagementPage = React.lazy(() => import('pages/ToolManagement/ToolManagementPage'));
const ToolReceiptPage = React.lazy(() => import('pages/ToolManagement/ToolReceiptPage'));
const ToolRequestPage = React.lazy(() => import('pages/ToolManagement/ToolRequestPage'));
const ToolGroupPage = React.lazy(() => import('pages/ToolManagement/ToolGroupPage'));
const AssetIntakePage = React.lazy(() => import('pages/AssetIntake/AssetIntakePage'));
const Product = React.lazy(() => import('pages/Product/Product'));
const ProductAdd = React.lazy(() => import('pages/Product/ProductAdd'));
const toolProducts = [
  { path: '/tool-management/products', exact: true, name: 'Danh sách công cụ dụng cụ', function: 'EQM_TOOL_PRODUCT_VIEW', component: () => <Product catalogScope='tools' /> },
  { path: '/tool-management/products/add', exact: true, name: 'Thêm mới công cụ dụng cụ', function: 'EQM_TOOL_PRODUCT_ADD', component: () => <ProductAdd catalogScope='tools' /> },
  { path: '/tool-management/products/detail/:product_id', exact: true, name: 'Chi tiết công cụ dụng cụ', function: 'EQM_TOOL_PRODUCT_VIEW', component: () => <ProductAdd catalogScope='tools' /> },
  { path: '/tool-management/products/edit/:product_id', exact: true, name: 'Chỉnh sửa công cụ dụng cụ', function: 'EQM_TOOL_PRODUCT_EDIT', component: () => <ProductAdd catalogScope='tools' /> },
  { path: '/tool-management/products/add/:product_id', exact: true, name: 'Sao chép công cụ dụng cụ', function: 'EQM_TOOL_PRODUCT_ADD', component: () => <ProductAdd catalogScope='tools' /> },
];

const toolManagementRoute = Object.keys(VIEWS).map((view) => ({
  path: view === 'dashboard' ? '/tool-management' : `/tool-management/${view}`,
  exact: true,
  name: VIEWS[view].title,
  function: view === 'settings'
    ? TOOL_PERMISSION.ACCOUNTING_CONFIG
    : view === 'repairs'
      ? TOOL_PERMISSION.REPAIR_VIEW
    : view === 'reports'
      ? TOOL_PERMISSION.REPORT_VIEW
      : TOOL_PERMISSION.VIEW,
  component: () => view === 'receipts' ? <ToolReceiptPage /> : <ToolManagementPage view={view} />,
}));

export default [...toolProducts, ...toolManagementRoute, { path: '/tool-management/pending', exact: true, name: 'CCDC chờ hoàn thiện', function: TOOL_PERMISSION.VIEW, component: () => <AssetIntakePage kind='TOOL' /> }, { path: '/tool-management/requests', exact: true, name: 'Yêu cầu cấp CCDC', function: TOOL_PERMISSION.VIEW, component: ToolRequestPage }, { path: '/tool-management/groups', exact: true, name: 'Nhóm công cụ dụng cụ', function: TOOL_PERMISSION.VIEW, component: ToolGroupPage }];
